import { render, staticRenderFns } from "./Limitions1.vue?vue&type=template&id=2509cb96"
import script from "./Limitions1.vue?vue&type=script&lang=js"
export * from "./Limitions1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports